import React, { createContext, useContext, useCallback, useMemo } from "react";
import { useWhatsAppInboxSSE } from "../hooks/useWhatsAppInboxSSE";

const WhatsAppEventsContext = createContext({
  connectionState: "idle",
  stats: {
    totalMessages: 0,
    unreadMessages: 0,
    conversations: 0,
    unreadConversations: 0,
  },
  lastInboxEvent: null,
});

export function WhatsAppEventsProvider({ children, enabled = true }) {
  // Toasts for every inbound WhatsApp reply were noisy (especially while Inbox
  // is off the side nav). Keep SSE for live inbox pages only — no global toast.
  const handleInboxMessage = useCallback(() => {}, []);

  const { connectionState, stats, lastInboxEvent } = useWhatsAppInboxSSE({
    enabled,
    onInboxMessage: handleInboxMessage,
  });

  const value = useMemo(
    () => ({
      connectionState,
      stats,
      lastInboxEvent,
    }),
    [connectionState, stats, lastInboxEvent]
  );

  return (
    <WhatsAppEventsContext.Provider value={value}>{children}</WhatsAppEventsContext.Provider>
  );
}

export function useWhatsAppEvents() {
  return useContext(WhatsAppEventsContext);
}

export default WhatsAppEventsContext;
